import { Service } from '../types';

export const services: Service[] = [
  {
    id: 'painting',
    title: 'Custom Painting',
    description:
      `Interior and exterior painting for homes and commercial spaces, with the preparation and coordination required for an even, lasting finish.`,
    longDescription:
      `A lasting paint job starts well before color goes on the wall. We assess the condition of each surface, handle the necessary preparation, and choose an approach suited to the material and use of the space. For a single room, a renovation, or an exterior project, we coordinate closely with homeowners, designers, architects, and contractors on scope, timing, colors, and sheens. The goal is simple: clean, consistent work that looks right in the space and holds up to daily life.`,
    image: 'services/Painting/barnes1.jpg',
    gallery: [
      `services/Painting/barnes1.jpg`,
      `services/Painting/barnes2.jpg`,
      `services/Painting/barnes3.jpg`,
      `services/Painting/gallery1.jpg`,
      `services/Painting/inside.jpg`,
      `services/Painting/rekean1.jpg`,
      `services/Painting/rekean2.jpg`,
      `services/Painting/rekean3.jpg`,
    ],
  },
  {
    id: 'plaster',
    title: 'Plaster & Venetian Plaster',
    description:
      `Plaster repair and decorative plaster finishes for interiors, from stabilizing older walls to creating considered texture in new spaces.`,
    longDescription:
      `Plaster asks for a close read of the surface beneath it. We begin by assessing the substrate and existing condition, then plan repairs or new finish work around the room's light, architecture, and intended use. Our work includes restoring damaged plaster and applying decorative finishes such as Venetian plaster. Each layer is built with care so the finished surface feels deliberate, not overworked.`,
    image: 'services/Plaster/newkean2.jpg',
    gallery: [
      `services/Plaster/newkean2.jpg`,
      `services/Plaster/plaster-texture1.jpg`,
      `services/Plaster/plaster-interior1.jpg`,
      `services/Plaster/plaster-wall1.jpg`,
    ],
  },
  {
    id: 'wood-finishing',
    title: 'Wood Finishing',
    description:
      `Staining, clear finishing, and restoration for millwork, cabinetry, floors, and other wood surfaces that deserve careful handling.`,
    longDescription:
      `Wood has its own character, and the finish should work with it. We prepare, stain, seal, and restore wood surfaces with attention to grain, existing coatings, color consistency, and how the piece will be used. Whether the project involves new millwork, cabinetry, or a floor that needs renewal, we test the approach where needed and keep the work coordinated with the surrounding materials.`,
    image: 'services/Wood Finishing/wood-detail1.jpg',
    gallery: [
      `services/Wood Finishing/barnes1.jpg`,
      `services/Wood Finishing/wood-detail1.jpg`,
      `services/Wood Finishing/wood-interior1.jpg`,
      `services/Wood Finishing/wood-finish1.jpg`,
    ],
  },
  {
    id: 'wallpaper',
    title: 'Wallpaper Installation',
    description:
      `Careful installation of wallcoverings, with the wall preparation, pattern matching, and material handling each product requires.`,
    longDescription:
      `Wallcovering installation depends on what happens before the first panel is hung. We prepare the wall, review the material and pattern, and plan how it will meet corners, openings, and other architectural details. From printed paper to grasscloth and textured products, we handle the alignment and adhesive requirements with care so the finished room reads as one complete surface.`,
    image: 'services/Wallpaper/wallpaper-room1.jpg',
    gallery: [
      `services/Wallpaper/barnes1.jpg`,
      `services/Wallpaper/wallpaper-pattern1.jpg`,
      `services/Wallpaper/wallpaper-room1.jpg`,
      `services/Wallpaper/wallpaper-detail1.jpg`,
    ],
  },
  {
    id: 'maintenance',
    title: 'Maintenance Programs',
    description:
      `Scheduled touch-ups, inspections, and upkeep that help finished spaces stay cared for as they are lived in and used.`,
    longDescription:
      `Well-finished spaces need occasional attention. Our maintenance programs are built around the surfaces, seasons, and use of a property, whether that means touch-ups, exterior reviews, or planned care for high-use areas. We document what we see, address small issues before they become larger projects, and keep the process straightforward for property owners and managers.`,
    image: 'services/Maintenance/maintenance-home1.jpg',
    gallery: [
      `services/Maintenance/barnes1.jpg`,
      `services/Maintenance/maintenance-exterior1.jpg`,
      `services/Maintenance/maintenance-home1.jpg`,
      `services/Maintenance/maintenance-detail1.jpg`,
    ],
  },
  {
    id: 'epoxy-floors',
    title: 'Epoxy Flooring',
    description:
      `Seamless epoxy floor systems for residential and commercial settings where a clean, hard-wearing surface is needed.`,
    longDescription:
      `An epoxy floor is only as sound as the slab beneath it. We start by evaluating and preparing the substrate, then select a system and finish suited to the space, its traffic, and its maintenance needs. Options can include different sheen levels, solid colors, aggregates, and decorative effects. We make the choices clearly before installation so the floor works with the rest of the project and the way the space will be used.`,
    image: 'services/Epoxy Floors/epoxy-floor1.jpg',
    gallery: [
      `services/Epoxy Floors/barnes1.jpg`,
      `services/Epoxy Floors/epoxy-floor1.jpg`,
      `services/Epoxy Floors/epoxy-modern1.jpg`,
      `services/Epoxy Floors/epoxy-space1.jpg`,
    ],
  },
  {
    id: 'commercial',
    title: 'Commercial Services',
    description:
      `Painting and finishing for commercial environments, planned around specifications, schedules, and the people using the space.`,
    longDescription:
      `Commercial work requires a clear plan and reliable communication. We coordinate with architects, contractors, building teams, and business owners to understand the specification, schedule, site conditions, and access requirements before work begins. From a targeted refresh to a larger phased project, we keep the scope organized and the work area respectful of the people who need to keep using it.`,
    image: 'services/Commercial/commercial-office1.jpg',
    gallery: [
      `services/Commercial/barnes1.jpg`,
      `services/Commercial/commercial-office1.jpg`,
      `services/Commercial/commercial-space1.jpg`,
      `services/Commercial/commercial-interior1.jpg`,
    ],
  },
];
